var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 12.0413C0.166748 5.70801 5.29175 0.583008 11.6251 0.583008H33.5001C38.1043 0.583008 41.8334 4.31217 41.8334 8.91634C41.8334 13.5205 38.1043 17.2497 33.5001 17.2497H15.7917C12.9167 17.2497 10.5834 14.9163 10.5834 12.0413C10.5834 9.16634 12.9167 6.83301 15.7917 6.83301H31.4167V10.9997H15.6042C14.4584 10.9997 14.4584 13.083 15.6042 13.083H33.5001C35.7918 13.083 37.6668 11.208 37.6668 8.91634C37.6668 6.62467 35.7918 4.74967 33.5001 4.74967H11.6251C7.60425 4.74967 4.33342 8.02051 4.33342 12.0413C4.33342 16.0622 7.60425 19.333 11.6251 19.333H31.4167V23.4997H11.6251C5.29175 23.4997 0.166748 18.3747 0.166748 12.0413Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.b845e465d4da341f15a7e37043b2c194.svg";
export { ForwardRef as ReactComponent };